import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class ReporteService {
  dataUrl = Config.URL_BASE + '/reporte';
  dataDocumentoUrl = Config.URL_BASE + '/reporte/documento';
  constructor(private http: HttpClient) {
  }

  getRepBalGen(empresa: number,mes: number,ano: number): Observable<any> {
    let url_ = this.dataUrl + '/rep_bal_gen/'+empresa+'/'+mes+'/'+ano+'';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  getRepBalGenXlsx(empresa: number,mes: number,ano: number): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_bal_gen/xlsx/' +empresa+'/'+mes+'/'+ano+'';
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  getRepBalGenPdf(empresa: number,mes: number,ano: number): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_bal_gen/pdf/' +empresa+'/'+mes+'/'+ano+'';
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepBalComp(empresa: number,mes: number,ano: number): Observable<any> {
    let url_ = this.dataUrl + '/rep_bal_comp/'+empresa+'/'+mes+'/'+ano+'';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  getRepBalCompXlsx(empresa: number,mes: number,ano: number, body: any): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_bal_comp/xlsx/' +empresa+'/'+mes+'/'+ano+'';
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_,body, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  
  getRepBalCompPdf(empresa: number,mes: number,ano: number, body: any): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_bal_comp/pdf/' +empresa+'/'+mes+'/'+ano+'';
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_,body, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepCtbCta(gral_emp_id: number,registros: number): Observable<any> {
    let url_ = this.dataUrl + '/rep_ctb_cta/'+gral_emp_id+'/'+registros;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepCueConPdf(gral_emp_id: number,registros: number, titulo_emp: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_cue_con/pdf/' +gral_emp_id+'/'+registros+'/'+titulo_emp;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepCueConXlsx(gral_emp_id: number,registros: number, titulo_emp: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_cue_con/xlsx/' +gral_emp_id+'/'+registros+'/'+titulo_emp;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getRepEstRes(gral_emp_id: number,mesIni: number,mesFin: number,anio: number): Observable<any> {
    let url_ = this.dataUrl + '/rep_est_res/' + gral_emp_id + '/' + mesIni + '/'+mesFin+'/'+anio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
 }
}